import { useCallback, useState } from 'react';
import * as auditService from '../services/auditService';
import { useUIStore } from '../stores/uiStore';
import { notifyApiError } from '../services/core/apiErrorUX';
import { IAuditFilters, IAuditLogItem } from '../types/interfaces/IAudit';
import { ApiResponse } from '../services/types';

export function useAudit() {
  const [loading, setLoading] = useState(false);
  const { addNotification } = useUIStore();

  const getAllAuditLogs = useCallback(
    async (filters: IAuditFilters): Promise<ApiResponse<IAuditLogItem[]>> => {
      setLoading(true);
      try {
        const response = await auditService.getAuditLogs(filters);
        if (!response.success) {
          notifyApiError(addNotification, response, {
            context: 'module',
            fallbackMessage: 'No se pudo cargar la auditoria',
          });
        }

        return response;
      } catch {
        addNotification({
          type: 'error',
          title: 'Error',
          message: 'No se pudo cargar la auditoria',
        });

        return {
          success: false,
          data: [],
          status: 500,
          error: 'No se pudo cargar la auditoria',
        };
      } finally {
        setLoading(false);
      }
    },
    [addNotification]
  );

  return {
    getAllAuditLogs,
    loading,
  };
}
